import type { CachedCaster } from './types';

/** Grant failures belong beside the controls; the pilot's other actions remain usable. */
export function renderPilotedAbilityRefusal(caster: CachedCaster): string {
    const reason = caster._piloted_ability_refusal;
    return typeof reason === 'string' && reason
        ? `<span class="text-warning" role="alert" data-ft-piloted-ability-refusal>${escapeHtml(reason)}</span>` : '';
}
